export enum PortfolioCompositionView {
  Accounts = 'accounts',
  InstrumentClass = 'instrumentClass',
  Instruments = 'instruments',
}
